import { render } from "./PendulumArduino.vue?vue&type=template&id=5e27f3a0"
import script from "./PendulumArduino.vue?vue&type=script&lang=js"
export * from "./PendulumArduino.vue?vue&type=script&lang=js"

import "./PendulumArduino.vue?vue&type=style&index=0&id=5e27f3a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__